import { Comments } from "./Comments";

const comments = new Comments();
